var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin"},[_c('Menu'),_c('p',[_vm._v("Bienvenue sur la nouvelle interface Admin.")]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":"/admin/admin_users.jsp"}},[_vm._v("Ancienne Admin")])])
}]

export { render, staticRenderFns }